export interface BaseUserSegment {
    id?: number,
    segment?: string
};

export interface UserSegments extends BaseUserSegment {
    updated: Date;
    uuid?: string;
    segments: BaseUserSegment;
}

export function isUserSegment(object: any): object is BaseUserSegment {
    return (<BaseUserSegment>object).segment !== undefined;
}